export function formatPackagingItemAuditRunTimestamp(
  timestamp: string,
  locale: string
): string {
  const date = new Date(timestamp)
  if (Number.isNaN(date.getTime())) {
    return timestamp
  }
  return new Intl.DateTimeFormat(locale, {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date)
}

const CHANGE_HISTORY_RELATIVE_TIME_MAX_MS = 7 * 24 * 60 * 60 * 1000

export function formatPackagingItemChangeHistoryTimestamp(
  timestamp: string,
  locale: string,
  now: Date = new Date()
): string {
  const date = new Date(timestamp)
  if (Number.isNaN(date.getTime())) {
    return timestamp
  }

  const diffMs = now.getTime() - date.getTime()
  if (diffMs >= 0 && diffMs < CHANGE_HISTORY_RELATIVE_TIME_MAX_MS) {
    const relativeTimeFormatter = new Intl.RelativeTimeFormat(locale, {
      numeric: 'auto',
    })

    if (diffMs < 60 * 1000) {
      const diffSeconds = Math.round(diffMs / 1000)
      if (diffSeconds < 60) {
        return relativeTimeFormatter.format(-Math.max(0, diffSeconds), 'second')
      }
    }

    const diffMinutes = Math.round(diffMs / (60 * 1000))
    if (diffMinutes < 60) {
      return relativeTimeFormatter.format(-diffMinutes, 'minute')
    }

    const diffHours = Math.round(diffMinutes / 60)
    if (diffHours < 24) {
      return relativeTimeFormatter.format(-diffHours, 'hour')
    }

    const diffDays = Math.round(diffHours / 24)
    return relativeTimeFormatter.format(-diffDays, 'day')
  }

  return new Intl.DateTimeFormat(locale, {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(date)
}
